// Apple-inspired Design System
// Based on iOS Human Interface Guidelines

const tintColorLight = '#007AFF'; // iOS Blue
const tintColorDark = '#0A84FF';

export default {
    light: {
        // Typography colors
        text: '#000000',
        textSecondary: 'rgba(60, 60, 67, 0.60)', // Label Secondary
        textTertiary: 'rgba(60, 60, 67, 0.30)', // Label Tertiary
        textMuted: '#8E8E93',

        // Backgrounds (iOS System)
        background: '#F2F2F7', // systemGroupedBackground
        backgroundSecondary: '#FFFFFF', // secondarySystemGroupedBackground (Cards)
        backgroundGrouped: '#F2F2F7',
        backgroundGroupedSecondary: '#FFFFFF',

        // UI Elements
        card: '#FFFFFF',
        border: '#C6C6C8', // separator
        inputBackground: '#FFFFFF',

        // Brand & Tints
        tint: tintColorLight,
        tabIconDefault: '#999999',
        tabIconSelected: tintColorLight,

        // System Colors
        primary: '#FF2D55', // App Brand Pink
        primaryLight: 'rgba(255, 45, 85, 0.1)',
        secondary: '#5856D6', // App Brand Purple
        secondaryLight: 'rgba(88, 86, 214, 0.1)',

        destructive: '#FF3B30', // systemRed
        success: '#34C759', // systemGreen
        warning: '#FFCC00', // systemYellow
        blue: '#007AFF',

        // Score Specific
        scoreGain: '#34C759',
        scoreGainBg: 'rgba(52, 199, 89, 0.1)',
        scoreLoss: '#FF3B30',
        scoreLossBg: 'rgba(255, 59, 48, 0.1)',

        // Shadows
        shadow: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.18,
            shadowRadius: 1.0,
            elevation: 1,
        },
        shadowCard: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.06,
            shadowRadius: 8,
            elevation: 2,
        },
    },
    dark: {
        // Typography colors
        text: '#FFFFFF',
        textSecondary: 'rgba(235, 235, 245, 0.60)',
        textTertiary: 'rgba(235, 235, 245, 0.30)',
        textMuted: '#8E8E93',

        // Backgrounds (iOS System Dark)
        background: '#000000', // systemGroupedBackground
        backgroundSecondary: '#1C1C1E', // secondarySystemGroupedBackground
        backgroundGrouped: '#000000',
        backgroundGroupedSecondary: '#1C1C1E',

        // UI Elements
        card: '#1C1C1E',
        border: '#38383A', // separator
        inputBackground: '#1C1C1E',

        // Brand & Tints
        tint: tintColorDark,
        tabIconDefault: '#8E8E93',
        tabIconSelected: tintColorDark,

        // System Colors
        primary: '#FF375F', // Dark Mode Pink
        primaryLight: 'rgba(255, 55, 95, 0.15)',
        secondary: '#5E5CE6', // Dark Mode Purple
        secondaryLight: 'rgba(94, 92, 230, 0.15)',

        destructive: '#FF453A',
        success: '#30D158',
        warning: '#FFD60A',
        blue: '#0A84FF',

        // Score Specific
        scoreGain: '#30D158',
        scoreGainBg: 'rgba(48, 209, 88, 0.15)',
        scoreLoss: '#FF453A',
        scoreLossBg: 'rgba(255, 69, 58, 0.15)',

        // Shadows typically invisible in pure dark mode, but useful for elevation
        shadow: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.3,
            shadowRadius: 2,
            elevation: 2,
        },
        shadowCard: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.3,
            shadowRadius: 8,
            elevation: 2,
        },
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 12,
        lg: 16,
        xl: 20,
        xxl: 24,
        xxxl: 32,
    },
    radius: {
        sm: 8,
        md: 12,
        lg: 16, // iOS standard curve
        xl: 20,
        card: 14, // iOS grouped table radius
        pill: 100,
    }
};
